import { privateApi } from "../api/axios";

export const getRoles = async () => {
    try {
        const response = await privateApi.get("api/roles");
        return response;
    } catch (error) {
        throw error;
    }
}